import { Outlet, Link } from "react-router-dom";

export const Layout: React.FC = () => {
    // Return our component
    return(
        // React Fragment Created 
        // <React.Fragment>
        <>
            <nav>
                <Link to="/">Home</Link> | {" "}
                <Link to="/contact">Contact</Link>
            </nav>
            <hr />
            <Outlet /> {/* Where child routes will render */}
        </>
    )
}